module.exports = __webpack_public_path__ + "static/media/album.8cf0cf3d.jpg";